import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				link: "openSubmenu",
			},
		};
	}

	init() {
		this.firstLink = this.$("link")[0];

		if (this.firstLink) {
			this.firstLink.classList.add("is-active");
		}

		this.links = this.$("link");
		this.children = this.$("child");
		this.groups = this.$("group");
		this.descriptions = this.$("description");
		this.actions = this.$("action");

		// Add is-active class to groups with data-index="1" by default
		this.groups.forEach((group) => {
			if (group.dataset.index === "1") {
				group.classList.add("is-active");
			}
		});

		// Add is-active class to descriptions with data-index="1" by default
		this.descriptions.forEach((description) => {
			if (description.dataset.index === "1") {
				description.classList.add("is-active");
			}
		});

		this.actions.forEach((action) => {
			if (action.dataset.index === "1") {
				action.classList.add("is-active");
			}
		});
	}

	openSubmenu(e) {
		//Logic for the links
		this.links.forEach((link) => {
			link.classList.remove("is-active");
		});

		e.currentTarget.classList.add("is-active");

		// Logic for the submenu
		let dataIndex = e.currentTarget.dataset.index;

		// Remove is-active class from all groups with a slight delay
		this.groups.forEach((group) => {
			group.classList.remove("is-active");
		});

		// Remove is-active class from all descriptions
		this.descriptions.forEach((description) => {
			description.classList.remove("is-active");
		});

		this.actions.forEach((action) => {
			action.classList.remove("is-active");
		});

		// Add a small delay before showing the new active group and description
		setTimeout(() => {
			// Add is-active class to the group with matching data-index
			this.groups.forEach((group) => {
				if (group.dataset.index === dataIndex) {
					group.classList.add("is-active");
				}
			});

			// Add is-active class to the description with matching data-index
			this.descriptions.forEach((description) => {
				if (description.dataset.index === dataIndex) {
					description.classList.add("is-active");
				}
			});

			// Add is-active class to the action button with matching data-index
			this.actions.forEach((action) => {
				if (action.dataset.index === dataIndex) {
					action.classList.add("is-active");
				}
			});
		}, 150); // 150ms delay to allow the previous animation to complete
	}

	destroy() {}
}
